export enum ColorOptionsEnum {
    STANDARD = "standard", 
    PREMIUM = "premium", 
    CUSTOM = "custom",
    WOODFINISH = "wood finish"
}